/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Reason_CouponInputs */

const fr_household_reason_coupon = /** @type {(inputs: Household_Reason_CouponInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de séances disponibles`)
};

/**

* @param {Household_Reason_CouponInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_reason_coupon = /** @type {((inputs?: Household_Reason_CouponInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Reason_CouponInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_reason_coupon(inputs)
});